import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const ExitDialog = ({ confirmExit, handleExitDialogClose, handleConfirmExit }) => {
  const uploadImageErrorActions = [
    <FlatButton
      label="Hætta við" labelStyle={{ color: '#222222' }}
      onTouchTap={handleExitDialogClose}
    />,
    <FlatButton
      label="Loka síðu" labelStyle={{ color: '#00e39a' }}
      onTouchTap={handleConfirmExit}
    />,
  ];

  return (
    <Dialog
      title="Ertu viss?" actions={uploadImageErrorActions}
      modal={false} open={confirmExit}
      onRequestClose={handleExitDialogClose}
    >
      Ertu viss um að þú viljir loka þessari síðu? <br /> <br />
      Engin af breytingunum sem þú hefur gert hafa verið vistaðar.
    </Dialog>
  );
};

ExitDialog.propTypes = {
  confirmExit: React.PropTypes.bool.isRequired,
  handleExitDialogClose: React.PropTypes.func.isRequired,
  handleConfirmExit: React.PropTypes.func.isRequired,
};

export default ExitDialog;



// WEBPACK FOOTER //
// ./src/browser/app/components/Dialogs/ExitDialog/ExitDialog.js